webpackJsonp([1],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(7);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(132);
	
	var _reactRouter = __webpack_require__(57);
	
	var _routes = __webpack_require__(205);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _reactDom.render)(_react2.default.createElement(_reactRouter.Router, { history: _reactRouter.browserHistory, routes: _routes2.default }), document.getElementById('app'));

/***/ },

/***/ 81:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.flushTitle = flushTitle;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(7);
	
	var _react2 = _interopRequireDefault(_react);
	
	var titles = [];
	
	function getTitle() {
	  return titles[titles.length - 1];
	}
	
	function updateTitle() {
	  document.title = getTitle();
	}
	
	function flushTitle() {
	  var title = getTitle();
	  titles = [];
	  return title;
	}
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var oneOfType = _React$PropTypes.oneOfType;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	var Title = _react2['default'].createClass({
	  displayName: 'Title',
	
	  propTypes: {
	    render: oneOfType([string, func]).isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      index: titles.push('') - 1
	    };
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    titles.pop();
	  },
	
	  componentDidMount: updateTitle,
	
	  componentDidUpdate: updateTitle,
	
	  render: function render() {
	    var render = this.props.render;
	
	    titles[this.state.index] = typeof render === 'function' ? render(titles[this.state.index - 1] || '') : render;
	    return this.props.children || null;
	  }
	
	});
	
	exports['default'] = Title;

/***/ },

/***/ 201:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(7);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(57);
	
	var _reactTitleComponent = __webpack_require__(81);
	
	var _reactTitleComponent2 = _interopRequireDefault(_reactTitleComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'App',
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactTitleComponent2.default, { render: 'Awesome App' }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Welcome to your app.'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _reactRouter.IndexLink,
	            { to: '/' },
	            'Home'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/dragon' },
	            'A DRAGON!'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/not-dragon' },
	            'An old URL to a DRAGON!'
	          )
	        )
	      ),
	      this.props.children
	    );
	  }
	});

/***/ },

/***/ 202:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(7);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dragon = __webpack_require__(302);
	
	var _dragon2 = _interopRequireDefault(_dragon);
	
	var _styles = __webpack_require__(304);
	
	var _reactTitleComponent = __webpack_require__(81);
	
	var _reactTitleComponent2 = _interopRequireDefault(_reactTitleComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'Dragon',
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactTitleComponent2.default, { render: function render(prev) {
	          return prev + ' | Dragon!';
	        } }),
	      _react2.default.createElement(
	        'h2',
	        { className: _styles.header },
	        'RAR!'
	      ),
	      _react2.default.createElement('img', { src: _dragon2.default, height: '400' })
	    );
	  }
	});

/***/ },

/***/ 203:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(7);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTitleComponent = __webpack_require__(81);
	
	var _reactTitleComponent2 = _interopRequireDefault(_reactTitleComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'Home',
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactTitleComponent2.default, { render: function render(prev) {
	          return prev + ' | Home';
	        } }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Home!'
	      )
	    );
	  }
	});

/***/ },

/***/ 204:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(7);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'NoMatch',
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      '404'
	    );
	  }
	});

/***/ },

/***/ 205:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(305);
	
	var _react = __webpack_require__(7);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(57);
	
	var _reactProject = __webpack_require__(120);
	
	var _hello = __webpack_require__(206);
	
	var _hello2 = _interopRequireDefault(_hello);
	
	var _App = __webpack_require__(201);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Home = __webpack_require__(203);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _NoMatch = __webpack_require__(204);
	
	var _NoMatch2 = _interopRequireDefault(_NoMatch);
	
	var _Dragon = __webpack_require__(202);
	
	var _Dragon2 = _interopRequireDefault(_Dragon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createElement(
	  _reactRouter.Route,
	  null,
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { path: '/', component: _App2.default },
	    _react2.default.createElement(_reactRouter.IndexRoute, { component: _Home2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'dragon', component: _Dragon2.default })
	  ),
	  _react2.default.createElement(
	    _reactProject.ServerRoute,
	    { path: '/api' },
	    _react2.default.createElement(_reactProject.ServerRoute, { path: ':hello', get: _hello2.default })
	  ),
	  _react2.default.createElement(_reactRouter.Redirect, { from: '/not-dragon', to: '/dragon' }),
	  _react2.default.createElement(_reactRouter.Route, { path: '*', status: 404, component: _NoMatch2.default })
	);

/***/ },

/***/ 206:
/***/ function(module, exports) {

	// empty (null-loader)
	"use strict";

/***/ },

/***/ 302:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1d6600c436721252b8048b7bc6bfb806.jpg";

/***/ },

/***/ 304:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"styles__header___P9w1l"};

/***/ },

/***/ 305:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }

});


/** WEBPACK FOOTER **
 ** a8a4e22ee2a0c880883f.js
 **/